module.exports = __webpack_public_path__ + "media/images/emblems/Marly-coat_of_arms-8fd30e7bd23080e6458b3dde0b6c0985.svg";